import { render, staticRenderFns } from "./contactNew.vue?vue&type=template&id=a68b0f44&"
import script from "./contactNew.vue?vue&type=script&lang=js&"
export * from "./contactNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports